
import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";

import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Responsive, WidthProvider } from "react-grid-layout";
import IncomingCallsSummary from './widgets/incomingcallssummary';
import OutgoingCallsSummary from "./widgets/outgoingcallssummary";
import QueueCallsSummary from "./widgets/queuecallssummary";
import SocialSummary from "./widgets/socialsummary";
import AgentsStatusSummary from "./widgets/agentsstatussummary";
import ServiceQuality from "./widgets/servicequality";
import AgentsPanel from "./widgets/agentspanel/agentspanel";
import CampaignsSummary from "./widgets/campaignssummary";
import CallsbyGroup from "./widgets/callsbygroup";
import CallsbyHour from "./widgets/callsbyhour";
import { updateWidget, removeWidget, updateLayout, emptyLayout, setLayout } from '../redux/supervisorSlice';
import AgentsDashboard from "./widgets/agentsdashboardv1";
import QueuedCallsDetail from "./widgets/queuedcallsdetail";
import CampaignsStatus from "./widgets/campaignsstatus/campaignsstatus";
import QueuedChatsdetail from "./widgets/queuedchatsdetail";
import GroupsStats from "./widgets/groupsstats";
import QueueCallsChart from "./widgets/queuecallschart";
import MaxWaitingTimeByHour from "./widgets/maxwaitingtimebyhour";
import DialersSummary from "./widgets/dialerssummary";
import DialersStatus from "./widgets/dialersstatus/dialersstatus";
import CampaignsStats from "./widgets/campaignsstats";
import PortsStatus from "./widgets/portsstatus/portsstatus";
import OutgoingChatsSummary from "./widgets/outgoingchatssummary";
import SentimentSummary from "./widgets/AIAnalysis/sentimentsummary";
import SentimentByGroup from "./widgets/AIAnalysis/sentimentbygroup";
import SentimentByHour from "./widgets/AIAnalysis/sentimentbyhour";
import AnalysisByCriteria from "./widgets/AIAnalysis/analysisbycriteria";
import AnalysisByCategory from "./widgets/AIAnalysis/analysisbycategory";
import AnalysisMoodTable from "./widgets/AIAnalysis/analysismoodtable";
import ActiveChats from "./widgets/activechats";

const ResponsiveGridLayout = WidthProvider(Responsive);

const widgetsMap = {

    incomingcallssummary: IncomingCallsSummary,
    outgoingcallssummary: OutgoingCallsSummary,
    queuecallssummary: QueueCallsSummary,
    socialsummary: SocialSummary,
    agentsstatussummary: AgentsStatusSummary,
    servicequality: ServiceQuality,
    agentscards: AgentsPanel,
    campaignssummary: CampaignsSummary,
    callsbygroup: CallsbyGroup,
    callsbyhour: CallsbyHour,
    agentsdashboard: AgentsDashboard,
    queuedcallsdetail: QueuedCallsDetail,
    campaignsstatus: CampaignsStatus,
    chatsqueuedetail: QueuedChatsdetail,
    groupsstats: GroupsStats,
    queuecallslinechart: QueueCallsChart,
    maxwaitingtimebyhour: MaxWaitingTimeByHour,
    dialerssummary: DialersSummary,
    dialersstatus: DialersStatus,
    campaignsstats: CampaignsStats,
    portsstatus: PortsStatus,
    outgoingchatssummary: OutgoingChatsSummary,
    sentimentsummary: SentimentSummary,
    sentimentbygroup: SentimentByGroup,
    sentimentbyhour: SentimentByHour,
    analysisbycriteria: AnalysisByCriteria,
    analysisbycategory: AnalysisByCategory,
    analysismoodtable: AnalysisMoodTable,
    activechats: ActiveChats
};

const WidgetContent = React.memo(({ elem, handleClose }) => {
    const Component = widgetsMap[elem.type];
    return Component ? <Component identifier={elem.i} close={handleClose} />
        : <div style={{ backgroundColor: "grey" }}>undefined</div>;
});
const Layout = React.memo(({ layout, handleResizeStop, handleDragStart, handleDragStop, handleClose, activeWidget, setActiveWidget }) => {

    const memoizedLayouts = React.useMemo(() => ({ lg: layout }), [layout]);

    return ((<ResponsiveGridLayout
        layouts={memoizedLayouts}
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 4, sm: 2, xs: 1, xxs: 1 }}
        rowHeight={60}
        onResizeStop={handleResizeStop}
        onDragStart={handleDragStart}
        onDragStop={handleDragStop}
        draggableHandle=".drag-handle">
        {
            layout?.map(elem => {
                const key = elem.i.toString();
                return (<div key={key} onClick={() => setActiveWidget(key)} style={{ zIndex: activeWidget === key ? 10 : 1 }}>
                    <WidgetContent elem={elem} handleClose={handleClose} />
                </div>);
            })
        }
    </ResponsiveGridLayout>
    ))

});

function Dashboard(props) {

    const [activeWidget, setActiveWidget] = useState(null);

    useEffect(() => {

        localStorage.removeItem("resizing");

        const saveLayout = () => {
            let dataStr = localStorage.getItem(`dashboardLayout_user${props.id}`);
            let data = JSON.parse(dataStr);
            if (data) {
                data.forEach(element => {
                    props.updateWidget(element);
                });
                localStorage.removeItem(`dashboardLayout_user${props.id}`);
            }
        };

        const handleBeforeUnload = (event) => {
            saveLayout();
        };


        window.addEventListener('beforeunload', handleBeforeUnload);

        //!PREVENTING MEMORY LEAK FROM DEVEXTREME
        const intervalId = setInterval(() => {

            let layoutStr = localStorage.getItem(`layout_user${props.id}`);
            let layout = JSON.parse(layoutStr);

            props.emptyLayout();
            setTimeout(() => {
                props.setLayout(layout);
            }, 1);
        }, 3_600_000);

        return () => {
            clearInterval(intervalId);
            saveLayout();
            window.removeEventListener('beforeunload', handleBeforeUnload);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (props.rtl) {
            const gridLayoutContainer = document.querySelector(".react-grid-layout");
            const children = document.querySelectorAll(".react-grid-item");

            gridLayoutContainer.setAttribute("dir", "ltr");
            children.forEach((child) => child.setAttribute("dir", "rtl"));
        }
    }, [props.layout, props.rtl])

    const handleResizeStop = useCallback((layout) => {
        layout.forEach(el => props.updateWidget(el));
    }, [props.updateWidget]);

    const handleDragStart = useCallback((layout, oldItem, newItem, placeholder, e, element) => {
        e.preventDefault();
        e.stopPropagation();

    }, []);

    const handleDragStop = useCallback((layout) => {
        layout.forEach(el => props.updateWidget(el));
    }, [props.updateWidget]);

    const handleClose = useCallback((itemId) => {
        props.removeWidget(itemId);
    }, [props.removeWidget]);

    return (<Layout layout={props.layout}
        handleResizeStop={handleResizeStop}
        handleDragStart={handleDragStart}
        handleDragStop={handleDragStop}
        handleClose={handleClose}
        activeWidget={activeWidget}
        setActiveWidget={setActiveWidget}
    />)
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        layout: state.supervisor.layout,
        rtl: state.parameters.rtl,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, { updateWidget, removeWidget, updateLayout, emptyLayout, setLayout })(Dashboard);
